import {axiosBase} from "@/api/axios-base";
import {URLS} from "@/api/config";
import {AxiosResponse} from "axios";
import {IBuyoutId} from "./config";

export const createNewBuyout = async (): Promise<AxiosResponse<IBuyoutId>> => {
    return await axiosBase.get(URLS.createNewBuyout())
}